import { GridCellParams, GridValidRowModel } from '@mui/x-data-grid-pro'
import React from 'react'
import DataGridCellWrapper from 'src/components/DataGrid/cells/DataGridCellWrapper/DataGridCellWrapper'
import { css } from 'styled-components'

interface IconsCellProps<Row extends GridValidRowModel> {
  icon: React.ReactElement | undefined
  disabled?: boolean
  params: GridCellParams<Row>
}

const IconsCell = <Row extends GridValidRowModel>(
  props: IconsCellProps<Row>,
): React.ReactElement => {
  const { icon, disabled, params } = props
  return (
    <DataGridCellWrapper disabled={disabled} params={params}>
      <div
        css={css`
          align-items: center;
          justify-content: center;
          display: flex;
        `}
      >
        {icon}
      </div>
    </DataGridCellWrapper>
  )
}

export default IconsCell
